<template>
  <v-dialog v-model="showDialog" scrollable max-width="800px">
    <v-card>
      <v-card-title>
        <strong>สร้างร้านค้าใหม่</strong>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text style="height: 450px;">
        <el-form :label-position="`left`" size="medium" label-width="100px" class="mt-3 pl-3">
          <el-form-item label="ชื่อร้านค้า">
            <el-col :span="19">
              <el-input v-model="form.shop_name"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="คำอธิบาย">
            <el-col :span="19">
              <el-input v-model="form.shop_excerpt"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="พิกัด">
            <el-col :span="9">
              <el-form-item>
                <el-input placeholder="latitude" v-model="form.shop_latitude"></el-input>
              </el-form-item>
            </el-col>
            <el-col class="line" :span="1">&nbsp;</el-col>
            <el-col :span="9">
              <el-form-item>
                <el-input placeholder="longitude" v-model="form.shop_longitude"></el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label="ที่อยู่">
            <el-col :span="19">
              <el-input v-model="form.shop_formatted_address"></el-input>
            </el-col>
          </el-form-item>
        </el-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" flat @click="showDialog = false">ปิด</v-btn>
        <v-btn color="red darken-2" flat @click="onSave">บันทึก</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import Service from "../services";
import { monthList } from "../utils/Constants";

export default {
  name: "create-shop-drawer",
  props: {
    dialog: { default: false }
  },
  data() {
    return {
      form: {
        shop_name: "",
        shop_excerpt: "",
        shop_latitude: "",
        shop_longitude: ""
      }
    };
  },
  computed: {
    showDialog: {
      get() {
        return this.dialog;
      },
      set(value) {
        // If close dialog.
        if (!value) {
          this.$emit("close");
        }
      }
    }
  },
  methods: {
    onSave() {
      Service.Shop.add(this.form).then(res => {
        if (res.success) {
          this.$emit("save");
        }
      });
    }
  }
};
</script>